/*
 * HomePage
 */

import React, { useEffect, useState } from 'react';

// Material Resources

// Others
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import moment from 'moment';

// Components & Others
import NotFound from '../NotFoundPage';
import EditMenu from '../../components/EditMenu';
import CognitoForm from '../../components/Cognito';
import { GET_RAISING_AND_FUND_INFORMATION } from '../../components/Cognito/queries';
import LoadingIndicator from '../../components/LoadingIndicator';
import { edgeToList } from '../../utils/commonFunctions';

function CognitoPage() {
  const { raisingID } = useParams();
  const [raising, setRaising] = useState(null);
  const [wheels, setWheels] = useState([]);

  const { data, loading } = useQuery(GET_RAISING_AND_FUND_INFORMATION, {
    variables: { raisingId: raisingID },
  });

  useEffect(() => {
    if (data) {
      setRaising(data.raising);
      setWheels(edgeToList(data.raising, 'wheelSet'));
    }
  }, [data]);

  function hasActiveWheel() {
    const nowDate = moment();
    const FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS ZZ';
    if (wheels && wheels.length) {
      return wheels.find(wheel => {
        const start = moment(wheel.dateInitial, FORMAT);
        const end = moment(wheel.dateEnd, FORMAT).endOf('day');
        return nowDate.isBetween(start, end, null, '[]');
      });
    }
    return false;
  }

  function notStartedWheel() {
    const nowDate = moment();
    if (wheels && wheels.length) {
      return wheels.find(wheel => nowDate.isBefore(wheel.dateInitial, 'days'));
    }
    return false;
  }

  function formatDate(date) {
    return moment(date.dateInitial).format('DD MMMM YYYY');
  }

  return loading ? (
    <LoadingIndicator />
  ) : !raising ? (
    <NotFound message="El levantamiento ha finalizado." />
  ) : hasActiveWheel(wheels) ? (
    <CognitoForm raising={raising} />
  ) : notStartedWheel(wheels) ? (
    <NotFound
      message={
        'El levantamiento empieza el ' + formatDate(notStartedWheel(wheels))
      }
    />
  ) : (
    <NotFound message="El levantamiento ha finalizado." />
  );
}

export default CognitoPage;
